import { render, staticRenderFns } from "./appSelect.vue?vue&type=template&id=085ffd1e&lang=pug&"
import script from "./appSelect.vue?vue&type=script&lang=js&"
export * from "./appSelect.vue?vue&type=script&lang=js&"
import style0 from "./appSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
